// extracted by mini-css-extract-plugin
export default {"info":"ScaleConfirmationModal-info","externalLink":"ScaleConfirmationModal-externalLink"};